/* eslint-disable */
import { Localizable } from '@salsita-ai/platform-common/utils'
import {
  AjvReflection,
  DomainEntityId,
  DomainEntityReflection,
  EntityReflections,
  EnumLike,
  EnumReflection,
  RawAliasReflection,
  SchemaOfObject,
} from '@salsita-ai/platform-project-sdk/domain'

export const modelVersion = 1

export type WallType = 'A' | 'B' | 'C'
export const WallType: EnumLike<WallType> = new EnumReflection('WallType', {
  enum: ['A', 'B', 'C'],
}) as EnumLike<WallType>

export type WallDirection = 'left' | 'right'
export const WallDirection: EnumLike<WallDirection> = new EnumReflection('WallDirection', {
  enum: ['left', 'right'],
}) as EnumLike<WallDirection>

export type CornerFillerType = 'AB' | 'BC'
export const CornerFillerType: EnumLike<CornerFillerType> = new EnumReflection('CornerFillerType', {
  enum: ['AB', 'BC'],
}) as EnumLike<CornerFillerType>

export type Handing = 'left' | 'right' | 'top' | 'both'
export const Handing: EnumLike<Handing> = new EnumReflection('Handing', {
  enum: ['left', 'right', 'top', 'both'],
}) as EnumLike<Handing>

export type RoomShapeType = 'L' | 'U' | 'I'
export const RoomShapeType: EnumLike<RoomShapeType> = new EnumReflection('RoomShapeType', {
  enum: ['L', 'U', 'I'],
}) as EnumLike<RoomShapeType>

export type CabinetColor =
  | 'Stainless'
  | 'Obsidian'
  | 'Glacier'
  | 'PacificBlue'
  | 'CaliforniaPoppy'
  | 'Surf'
  | 'DesertSage'
  | 'Limestone'
  | 'Sierra'
export const CabinetColor: EnumLike<CabinetColor> = new EnumReflection('CabinetColor', {
  type: 'string',
  enum: [
    'Stainless',
    'Obsidian',
    'Glacier',
    'PacificBlue',
    'CaliforniaPoppy',
    'Surf',
    'DesertSage',
    'Limestone',
    'Sierra',
  ],
}) as EnumLike<CabinetColor>

export type FuelType = 'None' | 'Propane' | 'NaturalGas'
export const FuelType: EnumLike<FuelType> = new EnumReflection('FuelType', {
  type: 'string',
  enum: ['None', 'Propane', 'NaturalGas'],
}) as EnumLike<FuelType>

export type LynxProfessionalGrillVariant = 'AllCeramic' | 'AllTrident' | 'TridentAndCeramic'
export const LynxProfessionalGrillVariant: EnumLike<LynxProfessionalGrillVariant> = new EnumReflection(
  'LynxProfessionalGrillVariant',
  {
    type: 'string',
    enum: ['AllCeramic', 'AllTrident', 'TridentAndCeramic'],
  }
) as EnumLike<LynxProfessionalGrillVariant>

export type LynxSedonaGrillVariant =
  | 'ProSear_SsBurner1'
  | 'ProSear_SsBurner1_Rotisserie'
  | 'SsBurner3'
  | 'ProSear_SsBurner2'
  | 'SsBurner3_Rotisserie'
  | 'ProSear_SsBurner2_Rotisserie'
export const LynxSedonaGrillVariant: EnumLike<LynxSedonaGrillVariant> = new EnumReflection('LynxSedonaGrillVariant', {
  type: 'string',
  enum: [
    'ProSear_SsBurner1',
    'ProSear_SsBurner1_Rotisserie',
    'SsBurner3',
    'ProSear_SsBurner2',
    'SsBurner3_Rotisserie',
    'ProSear_SsBurner2_Rotisserie',
  ],
}) as EnumLike<LynxSedonaGrillVariant>

export interface WallSummaryItem {
  readonly id: string
  readonly name: Localizable
  readonly sku: string
  readonly price: number
  readonly thumbnailUrl?: string
}
export const WallSummaryItem: AjvReflection<WallSummaryItem> = new AjvReflection('WallSummaryItem', {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      anyOf: [
        {
          type: 'string',
        },
        {
          type: 'object',
          properties: {
            id: {
              type: 'string',
            },
            comment: {
              type: 'string',
            },
            message: {
              type: 'string',
            },
            values: {
              type: 'object',
              additionalProperties: true,
            },
          },
          required: ['id'],
          additionalProperties: false,
        },
      ],
    },
    sku: {
      type: 'string',
    },
    price: {
      type: 'number',
    },
    thumbnailUrl: {
      type: 'string',
    },
  },
  required: ['id', 'name', 'sku', 'price'],
  additionalProperties: false,
})

export interface WallSummary {
  readonly id: string
  readonly name: Localizable
  readonly cabinets: readonly WallSummaryItem[]
  readonly parts: readonly WallSummaryItem[]
  readonly appliances: readonly WallSummaryItem[]
  [k: string]: unknown
}
export const WallSummary: AjvReflection<WallSummary> = new AjvReflection('WallSummary', {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      anyOf: [
        {
          type: 'string',
        },
        {
          type: 'object',
          properties: {
            id: {
              type: 'string',
            },
            comment: {
              type: 'string',
            },
            message: {
              type: 'string',
            },
            values: {
              type: 'object',
              additionalProperties: true,
            },
          },
          required: ['id'],
          additionalProperties: false,
        },
      ],
    },
    cabinets: {
      type: 'array',
      items: WallSummaryItem._meta.schema,
    },
    parts: {
      type: 'array',
      items: WallSummaryItem._meta.schema,
    },
    appliances: {
      type: 'array',
      items: WallSummaryItem._meta.schema,
    },
  },
  required: ['id', 'name', 'cabinets', 'parts', 'appliances'],
})

interface AdjustableDoorCabinetShape {
  readonly handing: Handing
}
const AdjustableDoorCabinetShape = new AjvReflection<AdjustableDoorCabinet, SchemaOfObject<AdjustableDoorCabinetShape>>(
  'AdjustableDoorCabinetShape',
  {
    type: 'object',
    properties: {
      handing: Handing._meta.schema,
    },
    additionalProperties: false,
    required: ['handing'],
  }
)

interface CabinetWithApplianceShape {
  readonly applianceId: Appliance['id']
}
const CabinetWithApplianceShape = new AjvReflection<CabinetWithAppliance, SchemaOfObject<CabinetWithApplianceShape>>(
  'CabinetWithApplianceShape',
  {
    type: 'object',
    properties: {
      applianceId: {
        type: 'string',
        pattern: '^[A-Z]\\w*-\\d+$',
      },
    },
    additionalProperties: false,
    required: ['applianceId'],
  }
)

interface WallItemShape {
  readonly wallId: Wall['id']
  readonly x: number
}
const WallItemShape = new AjvReflection<WallItem, SchemaOfObject<WallItemShape>>('WallItemShape', {
  type: 'object',
  properties: {
    wallId: {
      type: 'string',
      pattern: '^[A-Z]\\w*-\\d+$',
    },
    x: {
      type: 'number',
    },
  },
  additionalProperties: false,
  required: ['wallId', 'x'],
})

interface Drawer33Door66Shape {
  readonly width: 457.2 | 609.6
}
const Drawer33Door66Shape = new AjvReflection<Drawer33Door66, SchemaOfObject<Drawer33Door66Shape>>(
  'Drawer33Door66Shape',
  {
    type: 'object',
    properties: {
      width: {
        type: 'number',
        enum: [457.2, 609.6],
      },
    },
    additionalProperties: false,
    required: ['width'],
  }
)

interface FillerShape {
  readonly width:
    | 25.4
    | 31.75
    | 38.1
    | 44.45
    | 50.8
    | 57.15
    | 63.5
    | 69.85
    | 76.2
    | 82.55
    | 88.9
    | 95.25
    | 101.6
    | 107.95
    | 114.3
    | 120.65
    | 127
}
const FillerShape = new AjvReflection<Filler, SchemaOfObject<FillerShape>>('FillerShape', {
  type: 'object',
  properties: {
    width: {
      type: 'number',
      enum: [
        25.4, 31.75, 38.1, 44.45, 50.8, 57.15, 63.5, 69.85, 76.2, 82.55, 88.9, 95.25, 101.6, 107.95, 114.3, 120.65, 127,
      ],
    },
  },
  additionalProperties: false,
  required: ['width'],
})

interface FullDoorBaseShape {
  readonly width: 457.2 | 609.6
}
const FullDoorBaseShape = new AjvReflection<FullDoorBase, SchemaOfObject<FullDoorBaseShape>>('FullDoorBaseShape', {
  type: 'object',
  properties: {
    width: {
      type: 'number',
      enum: [457.2, 609.6],
    },
  },
  additionalProperties: false,
  required: ['width'],
})

interface GrillBaseShape {
  readonly width: 914.4 | 1066.8 | 1219.2 | 1524
}
const GrillBaseShape = new AjvReflection<GrillBase, SchemaOfObject<GrillBaseShape>>('GrillBaseShape', {
  type: 'object',
  properties: {
    width: {
      type: 'number',
      enum: [914.4, 1066.8, 1219.2, 1524],
    },
  },
  additionalProperties: false,
  required: ['width'],
})

interface LynxProfessionalGrillW30Shape {
  readonly variant: string
}
const LynxProfessionalGrillW30Shape = new AjvReflection<
  LynxProfessionalGrillW30,
  SchemaOfObject<LynxProfessionalGrillW30Shape>
>('LynxProfessionalGrillW30Shape', {
  type: 'object',
  properties: {
    variant: {
      type: 'string',
    },
  },
  additionalProperties: false,
  required: ['variant'],
})

interface LynxProfessionalGrillW36Shape {
  readonly variant: string
}
const LynxProfessionalGrillW36Shape = new AjvReflection<
  LynxProfessionalGrillW36,
  SchemaOfObject<LynxProfessionalGrillW36Shape>
>('LynxProfessionalGrillW36Shape', {
  type: 'object',
  properties: {
    variant: {
      type: 'string',
    },
  },
  additionalProperties: false,
  required: ['variant'],
})

interface LynxProfessionalGrillW42Shape {
  readonly variant: string
}
const LynxProfessionalGrillW42Shape = new AjvReflection<
  LynxProfessionalGrillW42,
  SchemaOfObject<LynxProfessionalGrillW42Shape>
>('LynxProfessionalGrillW42Shape', {
  type: 'object',
  properties: {
    variant: {
      type: 'string',
    },
  },
  additionalProperties: false,
  required: ['variant'],
})

interface LynxProfessionalGrillW54Shape {
  readonly variant: string
}
const LynxProfessionalGrillW54Shape = new AjvReflection<
  LynxProfessionalGrillW54,
  SchemaOfObject<LynxProfessionalGrillW54Shape>
>('LynxProfessionalGrillW54Shape', {
  type: 'object',
  properties: {
    variant: {
      type: 'string',
    },
  },
  additionalProperties: false,
  required: ['variant'],
})

interface LynxSedonaGrillW30Shape {
  readonly variant: string
}
const LynxSedonaGrillW30Shape = new AjvReflection<LynxSedonaGrillW30, SchemaOfObject<LynxSedonaGrillW30Shape>>(
  'LynxSedonaGrillW30Shape',
  {
    type: 'object',
    properties: {
      variant: {
        type: 'string',
      },
    },
    additionalProperties: false,
    required: ['variant'],
  }
)

interface LynxSedonaGrillW36Shape {
  readonly variant: string
}
const LynxSedonaGrillW36Shape = new AjvReflection<LynxSedonaGrillW36, SchemaOfObject<LynxSedonaGrillW36Shape>>(
  'LynxSedonaGrillW36Shape',
  {
    type: 'object',
    properties: {
      variant: {
        type: 'string',
      },
    },
    additionalProperties: false,
    required: ['variant'],
  }
)

interface LynxSedonaGrillW42Shape {
  readonly variant: string
}
const LynxSedonaGrillW42Shape = new AjvReflection<LynxSedonaGrillW42, SchemaOfObject<LynxSedonaGrillW42Shape>>(
  'LynxSedonaGrillW42Shape',
  {
    type: 'object',
    properties: {
      variant: {
        type: 'string',
      },
    },
    additionalProperties: false,
    required: ['variant'],
  }
)

interface RoomShape {
  readonly shape: RoomShapeType
  readonly cabinetColor: CabinetColor
  readonly fuelType: FuelType
  readonly includeCabinets: boolean
  readonly includeGrill: boolean
  readonly includeBurner: boolean
  readonly includeOtherCookingItem: boolean
  readonly includeHood: boolean
  readonly includeRefrigerator: boolean
  readonly includeSink: boolean
  readonly stainlessSafeEnvironment: boolean
}
const RoomShape = new AjvReflection<Room, SchemaOfObject<RoomShape>>('RoomShape', {
  type: 'object',
  properties: {
    shape: RoomShapeType._meta.schema,
    cabinetColor: CabinetColor._meta.schema,
    fuelType: FuelType._meta.schema,
    includeCabinets: {
      type: 'boolean',
    },
    includeGrill: {
      type: 'boolean',
    },
    includeBurner: {
      type: 'boolean',
    },
    includeOtherCookingItem: {
      type: 'boolean',
    },
    includeHood: {
      type: 'boolean',
    },
    includeRefrigerator: {
      type: 'boolean',
    },
    includeSink: {
      type: 'boolean',
    },
    stainlessSafeEnvironment: {
      type: 'boolean',
    },
  },
  additionalProperties: false,
  required: [
    'shape',
    'cabinetColor',
    'fuelType',
    'includeCabinets',
    'includeGrill',
    'includeBurner',
    'includeOtherCookingItem',
    'includeHood',
    'includeRefrigerator',
    'includeSink',
    'stainlessSafeEnvironment',
  ],
})

interface SinkBaseShape {
  readonly width: 609.6 | 914.4 | 1219.2
}
const SinkBaseShape = new AjvReflection<SinkBase, SchemaOfObject<SinkBaseShape>>('SinkBaseShape', {
  type: 'object',
  properties: {
    width: {
      type: 'number',
      enum: [609.6, 914.4, 1219.2],
    },
  },
  additionalProperties: false,
  required: ['width'],
})

interface ThreeDrawerBaseShape {
  readonly width: 457.2 | 609.6
}
const ThreeDrawerBaseShape = new AjvReflection<ThreeDrawerBase, SchemaOfObject<ThreeDrawerBaseShape>>(
  'ThreeDrawerBaseShape',
  {
    type: 'object',
    properties: {
      width: {
        type: 'number',
        enum: [457.2, 609.6],
      },
    },
    additionalProperties: false,
    required: ['width'],
  }
)

interface TrashPulloutBaseShape {
  readonly width: 457.2 | 609.6
}
const TrashPulloutBaseShape = new AjvReflection<TrashPulloutBase, SchemaOfObject<TrashPulloutBaseShape>>(
  'TrashPulloutBaseShape',
  {
    type: 'object',
    properties: {
      width: {
        type: 'number',
        enum: [457.2, 609.6],
      },
    },
    additionalProperties: false,
    required: ['width'],
  }
)

interface WallShape {
  readonly wallType: WallType
  readonly length: number
  readonly fullHeight: boolean
  readonly hidden: boolean
}
const WallShape = new AjvReflection<Wall, SchemaOfObject<WallShape>>('WallShape', {
  type: 'object',
  properties: {
    wallType: WallType._meta.schema,
    length: {
      type: 'number',
    },
    fullHeight: {
      type: 'boolean',
    },
    hidden: {
      type: 'boolean',
    },
  },
  additionalProperties: false,
  required: ['wallType', 'length', 'fullHeight', 'hidden'],
})

interface CornerFillerShape {
  readonly connerFillerType: CornerFillerType
}
const CornerFillerShape = new AjvReflection<CornerFiller, SchemaOfObject<CornerFillerShape>>('CornerFillerShape', {
  type: 'object',
  properties: {
    connerFillerType: CornerFillerType._meta.schema,
  },
  additionalProperties: false,
  required: ['connerFillerType'],
})

export interface BurnerBaseW18 extends AdjustableDoorCabinetShape, CabinetWithApplianceShape, WallItemShape {
  readonly id: DomainEntityId<'BurnerBaseW18'>
  readonly type: 'BurnerBaseW18'
}
export const BurnerBaseW18: DomainEntityReflection<BurnerBaseW18> = new DomainEntityReflection<BurnerBaseW18>(
  'BurnerBaseW18',
  [AdjustableDoorCabinetShape._meta.schema, CabinetWithApplianceShape._meta.schema, WallItemShape._meta.schema]
)

export interface BurnerBaseW24 extends AdjustableDoorCabinetShape, CabinetWithApplianceShape, WallItemShape {
  readonly id: DomainEntityId<'BurnerBaseW24'>
  readonly type: 'BurnerBaseW24'
}
export const BurnerBaseW24: DomainEntityReflection<BurnerBaseW24> = new DomainEntityReflection<BurnerBaseW24>(
  'BurnerBaseW24',
  [AdjustableDoorCabinetShape._meta.schema, CabinetWithApplianceShape._meta.schema, WallItemShape._meta.schema]
)

export interface CornerFiller extends CornerFillerShape {
  readonly id: DomainEntityId<'CornerFiller'>
  readonly type: 'CornerFiller'
}
export const CornerFiller: DomainEntityReflection<CornerFiller> = new DomainEntityReflection<CornerFiller>(
  'CornerFiller',
  [CornerFillerShape._meta.schema]
)

export interface Drawer33Door66 extends Drawer33Door66Shape, AdjustableDoorCabinetShape, WallItemShape {
  readonly id: DomainEntityId<'Drawer33Door66'>
  readonly type: 'Drawer33Door66'
}
export const Drawer33Door66: DomainEntityReflection<Drawer33Door66> = new DomainEntityReflection<Drawer33Door66>(
  'Drawer33Door66',
  [Drawer33Door66Shape._meta.schema, AdjustableDoorCabinetShape._meta.schema, WallItemShape._meta.schema]
)

export interface EvoBaseW36 extends AdjustableDoorCabinetShape, CabinetWithApplianceShape, WallItemShape {
  readonly id: DomainEntityId<'EvoBaseW36'>
  readonly type: 'EvoBaseW36'
}
export const EvoBaseW36: DomainEntityReflection<EvoBaseW36> = new DomainEntityReflection<EvoBaseW36>('EvoBaseW36', [
  AdjustableDoorCabinetShape._meta.schema,
  CabinetWithApplianceShape._meta.schema,
  WallItemShape._meta.schema,
])

export interface EvoAffinity25G {
  readonly id: DomainEntityId<'EvoAffinity25G'>
  readonly type: 'EvoAffinity25G'
}
export const EvoAffinity25G: DomainEntityReflection<EvoAffinity25G> = new DomainEntityReflection<EvoAffinity25G>(
  'EvoAffinity25G',
  []
)

export interface EvoAffinity30G {
  readonly id: DomainEntityId<'EvoAffinity30G'>
  readonly type: 'EvoAffinity30G'
}
export const EvoAffinity30G: DomainEntityReflection<EvoAffinity30G> = new DomainEntityReflection<EvoAffinity30G>(
  'EvoAffinity30G',
  []
)

export interface Filler extends FillerShape, WallItemShape {
  readonly id: DomainEntityId<'Filler'>
  readonly type: 'Filler'
}
export const Filler: DomainEntityReflection<Filler> = new DomainEntityReflection<Filler>('Filler', [
  FillerShape._meta.schema,
  WallItemShape._meta.schema,
])

export interface FullDoorBase extends FullDoorBaseShape, AdjustableDoorCabinetShape, WallItemShape {
  readonly id: DomainEntityId<'FullDoorBase'>
  readonly type: 'FullDoorBase'
}
export const FullDoorBase: DomainEntityReflection<FullDoorBase> = new DomainEntityReflection<FullDoorBase>(
  'FullDoorBase',
  [FullDoorBaseShape._meta.schema, AdjustableDoorCabinetShape._meta.schema, WallItemShape._meta.schema]
)

export interface GrillBase
  extends GrillBaseShape,
    AdjustableDoorCabinetShape,
    CabinetWithApplianceShape,
    WallItemShape {
  readonly id: DomainEntityId<'GrillBase'>
  readonly type: 'GrillBase'
}
export const GrillBase: DomainEntityReflection<GrillBase> = new DomainEntityReflection<GrillBase>('GrillBase', [
  GrillBaseShape._meta.schema,
  AdjustableDoorCabinetShape._meta.schema,
  CabinetWithApplianceShape._meta.schema,
  WallItemShape._meta.schema,
])

export interface LynxAsadoGriddgle {
  readonly id: DomainEntityId<'LynxAsadoGriddgle'>
  readonly type: 'LynxAsadoGriddgle'
}
export const LynxAsadoGriddgle: DomainEntityReflection<LynxAsadoGriddgle> =
  new DomainEntityReflection<LynxAsadoGriddgle>('LynxAsadoGriddgle', [])

export interface LynxProfessionalGrillW30 extends LynxProfessionalGrillW30Shape {
  readonly id: DomainEntityId<'LynxProfessionalGrillW30'>
  readonly type: 'LynxProfessionalGrillW30'
}
export const LynxProfessionalGrillW30: DomainEntityReflection<LynxProfessionalGrillW30> =
  new DomainEntityReflection<LynxProfessionalGrillW30>('LynxProfessionalGrillW30', [
    LynxProfessionalGrillW30Shape._meta.schema,
  ])

export interface LynxProfessionalGrillW36 extends LynxProfessionalGrillW36Shape {
  readonly id: DomainEntityId<'LynxProfessionalGrillW36'>
  readonly type: 'LynxProfessionalGrillW36'
}
export const LynxProfessionalGrillW36: DomainEntityReflection<LynxProfessionalGrillW36> =
  new DomainEntityReflection<LynxProfessionalGrillW36>('LynxProfessionalGrillW36', [
    LynxProfessionalGrillW36Shape._meta.schema,
  ])

export interface LynxProfessionalGrillW42 extends LynxProfessionalGrillW42Shape {
  readonly id: DomainEntityId<'LynxProfessionalGrillW42'>
  readonly type: 'LynxProfessionalGrillW42'
}
export const LynxProfessionalGrillW42: DomainEntityReflection<LynxProfessionalGrillW42> =
  new DomainEntityReflection<LynxProfessionalGrillW42>('LynxProfessionalGrillW42', [
    LynxProfessionalGrillW42Shape._meta.schema,
  ])

export interface LynxProfessionalGrillW54 extends LynxProfessionalGrillW54Shape {
  readonly id: DomainEntityId<'LynxProfessionalGrillW54'>
  readonly type: 'LynxProfessionalGrillW54'
}
export const LynxProfessionalGrillW54: DomainEntityReflection<LynxProfessionalGrillW54> =
  new DomainEntityReflection<LynxProfessionalGrillW54>('LynxProfessionalGrillW54', [
    LynxProfessionalGrillW54Shape._meta.schema,
  ])

export interface LynxProfessionalSingleBurner {
  readonly id: DomainEntityId<'LynxProfessionalSingleBurner'>
  readonly type: 'LynxProfessionalSingleBurner'
}
export const LynxProfessionalSingleBurner: DomainEntityReflection<LynxProfessionalSingleBurner> =
  new DomainEntityReflection<LynxProfessionalSingleBurner>('LynxProfessionalSingleBurner', [])

export interface LynxProfessionalDoubleBurner {
  readonly id: DomainEntityId<'LynxProfessionalDoubleBurner'>
  readonly type: 'LynxProfessionalDoubleBurner'
}
export const LynxProfessionalDoubleBurner: DomainEntityReflection<LynxProfessionalDoubleBurner> =
  new DomainEntityReflection<LynxProfessionalDoubleBurner>('LynxProfessionalDoubleBurner', [])

export interface LynxProfessionalPowerBurner {
  readonly id: DomainEntityId<'LynxProfessionalPowerBurner'>
  readonly type: 'LynxProfessionalPowerBurner'
}
export const LynxProfessionalPowerBurner: DomainEntityReflection<LynxProfessionalPowerBurner> =
  new DomainEntityReflection<LynxProfessionalPowerBurner>('LynxProfessionalPowerBurner', [])

export interface LynxSedonaGrillW30 extends LynxSedonaGrillW30Shape {
  readonly id: DomainEntityId<'LynxSedonaGrillW30'>
  readonly type: 'LynxSedonaGrillW30'
}
export const LynxSedonaGrillW30: DomainEntityReflection<LynxSedonaGrillW30> =
  new DomainEntityReflection<LynxSedonaGrillW30>('LynxSedonaGrillW30', [LynxSedonaGrillW30Shape._meta.schema])

export interface LynxSedonaGrillW36 extends LynxSedonaGrillW36Shape {
  readonly id: DomainEntityId<'LynxSedonaGrillW36'>
  readonly type: 'LynxSedonaGrillW36'
}
export const LynxSedonaGrillW36: DomainEntityReflection<LynxSedonaGrillW36> =
  new DomainEntityReflection<LynxSedonaGrillW36>('LynxSedonaGrillW36', [LynxSedonaGrillW36Shape._meta.schema])

export interface LynxSedonaGrillW42 extends LynxSedonaGrillW42Shape {
  readonly id: DomainEntityId<'LynxSedonaGrillW42'>
  readonly type: 'LynxSedonaGrillW42'
}
export const LynxSedonaGrillW42: DomainEntityReflection<LynxSedonaGrillW42> =
  new DomainEntityReflection<LynxSedonaGrillW42>('LynxSedonaGrillW42', [LynxSedonaGrillW42Shape._meta.schema])

export interface LynxSedonaSingleBurner {
  readonly id: DomainEntityId<'LynxSedonaSingleBurner'>
  readonly type: 'LynxSedonaSingleBurner'
}
export const LynxSedonaSingleBurner: DomainEntityReflection<LynxSedonaSingleBurner> =
  new DomainEntityReflection<LynxSedonaSingleBurner>('LynxSedonaSingleBurner', [])

export interface LynxSedonaDoubleBurner {
  readonly id: DomainEntityId<'LynxSedonaDoubleBurner'>
  readonly type: 'LynxSedonaDoubleBurner'
}
export const LynxSedonaDoubleBurner: DomainEntityReflection<LynxSedonaDoubleBurner> =
  new DomainEntityReflection<LynxSedonaDoubleBurner>('LynxSedonaDoubleBurner', [])

export interface Room extends RoomShape {
  readonly id: DomainEntityId<'Room'>
  readonly type: 'Room'
}
export const Room: DomainEntityReflection<Room> = new DomainEntityReflection<Room>('Room', [RoomShape._meta.schema])

export interface SinkBase extends SinkBaseShape, AdjustableDoorCabinetShape, WallItemShape {
  readonly id: DomainEntityId<'SinkBase'>
  readonly type: 'SinkBase'
}
export const SinkBase: DomainEntityReflection<SinkBase> = new DomainEntityReflection<SinkBase>('SinkBase', [
  SinkBaseShape._meta.schema,
  AdjustableDoorCabinetShape._meta.schema,
  WallItemShape._meta.schema,
])

export interface ThreeDrawerBase extends ThreeDrawerBaseShape, WallItemShape {
  readonly id: DomainEntityId<'ThreeDrawerBase'>
  readonly type: 'ThreeDrawerBase'
}
export const ThreeDrawerBase: DomainEntityReflection<ThreeDrawerBase> = new DomainEntityReflection<ThreeDrawerBase>(
  'ThreeDrawerBase',
  [ThreeDrawerBaseShape._meta.schema, WallItemShape._meta.schema]
)

export interface TrashPulloutBase extends TrashPulloutBaseShape, AdjustableDoorCabinetShape, WallItemShape {
  readonly id: DomainEntityId<'TrashPulloutBase'>
  readonly type: 'TrashPulloutBase'
}
export const TrashPulloutBase: DomainEntityReflection<TrashPulloutBase> = new DomainEntityReflection<TrashPulloutBase>(
  'TrashPulloutBase',
  [TrashPulloutBaseShape._meta.schema, AdjustableDoorCabinetShape._meta.schema, WallItemShape._meta.schema]
)

export interface Wall extends WallShape {
  readonly id: DomainEntityId<'Wall'>
  readonly type: 'Wall'
}
export const Wall: DomainEntityReflection<Wall> = new DomainEntityReflection<Wall>('Wall', [WallShape._meta.schema])

export type AnyDomainEntity =
  | BurnerBaseW18
  | BurnerBaseW24
  | CornerFiller
  | Drawer33Door66
  | EvoBaseW36
  | EvoAffinity25G
  | EvoAffinity30G
  | Filler
  | FullDoorBase
  | GrillBase
  | LynxAsadoGriddgle
  | LynxProfessionalGrillW30
  | LynxProfessionalGrillW36
  | LynxProfessionalGrillW42
  | LynxProfessionalGrillW54
  | LynxProfessionalSingleBurner
  | LynxProfessionalDoubleBurner
  | LynxProfessionalPowerBurner
  | LynxSedonaGrillW30
  | LynxSedonaGrillW36
  | LynxSedonaGrillW42
  | LynxSedonaSingleBurner
  | LynxSedonaDoubleBurner
  | Room
  | SinkBase
  | ThreeDrawerBase
  | TrashPulloutBase
  | Wall
export const AnyDomainEntity: RawAliasReflection<AnyDomainEntity> = new RawAliasReflection<AnyDomainEntity>(
  'AnyDomainEntity',
  [
    BurnerBaseW18,
    BurnerBaseW24,
    CornerFiller,
    Drawer33Door66,
    EvoBaseW36,
    EvoAffinity25G,
    EvoAffinity30G,
    Filler,
    FullDoorBase,
    GrillBase,
    LynxAsadoGriddgle,
    LynxProfessionalGrillW30,
    LynxProfessionalGrillW36,
    LynxProfessionalGrillW42,
    LynxProfessionalGrillW54,
    LynxProfessionalSingleBurner,
    LynxProfessionalDoubleBurner,
    LynxProfessionalPowerBurner,
    LynxSedonaGrillW30,
    LynxSedonaGrillW36,
    LynxSedonaGrillW42,
    LynxSedonaSingleBurner,
    LynxSedonaDoubleBurner,
    Room,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase,
    Wall,
  ]
)

export type RootEntity = Room
export const RootEntity: RawAliasReflection<RootEntity> = new RawAliasReflection<RootEntity>('RootEntity', [Room])

export type StaticEntity = Room | Wall | CornerFiller
export const StaticEntity: RawAliasReflection<StaticEntity> = new RawAliasReflection<StaticEntity>('StaticEntity', [
  Room,
  Wall,
  CornerFiller,
])

export type AdjustableDoorCabinet =
  | BurnerBaseW18
  | BurnerBaseW24
  | Drawer33Door66
  | EvoBaseW36
  | FullDoorBase
  | GrillBase
  | SinkBase
  | TrashPulloutBase
export const AdjustableDoorCabinet: RawAliasReflection<AdjustableDoorCabinet> =
  new RawAliasReflection<AdjustableDoorCabinet>('AdjustableDoorCabinet', [
    BurnerBaseW18,
    BurnerBaseW24,
    Drawer33Door66,
    EvoBaseW36,
    FullDoorBase,
    GrillBase,
    SinkBase,
    TrashPulloutBase,
  ])

export type Appliance =
  | LynxAsadoGriddgle
  | LynxProfessionalGrillW30
  | LynxProfessionalGrillW36
  | LynxProfessionalGrillW42
  | LynxProfessionalGrillW54
  | LynxSedonaGrillW30
  | LynxSedonaGrillW36
  | LynxSedonaGrillW42
  | LynxProfessionalSingleBurner
  | LynxProfessionalDoubleBurner
  | LynxProfessionalPowerBurner
  | LynxSedonaSingleBurner
  | LynxSedonaDoubleBurner
  | EvoAffinity25G
  | EvoAffinity30G
export const Appliance: RawAliasReflection<Appliance> = new RawAliasReflection<Appliance>('Appliance', [
  LynxAsadoGriddgle,
  LynxProfessionalGrillW30,
  LynxProfessionalGrillW36,
  LynxProfessionalGrillW42,
  LynxProfessionalGrillW54,
  LynxSedonaGrillW30,
  LynxSedonaGrillW36,
  LynxSedonaGrillW42,
  LynxProfessionalSingleBurner,
  LynxProfessionalDoubleBurner,
  LynxProfessionalPowerBurner,
  LynxSedonaSingleBurner,
  LynxSedonaDoubleBurner,
  EvoAffinity25G,
  EvoAffinity30G,
])

export type BurnerBase = BurnerBaseW18 | BurnerBaseW24
export const BurnerBase: RawAliasReflection<BurnerBase> = new RawAliasReflection<BurnerBase>('BurnerBase', [
  BurnerBaseW18,
  BurnerBaseW24,
])

export type CabinetWithAppliance = BurnerBaseW18 | BurnerBaseW24 | EvoBaseW36 | GrillBase
export const CabinetWithAppliance: RawAliasReflection<CabinetWithAppliance> =
  new RawAliasReflection<CabinetWithAppliance>('CabinetWithAppliance', [
    BurnerBaseW18,
    BurnerBaseW24,
    EvoBaseW36,
    GrillBase,
  ])

export type CabinetWithoutAppliance = Drawer33Door66 | FullDoorBase | SinkBase | ThreeDrawerBase | TrashPulloutBase
export const CabinetWithoutAppliance: RawAliasReflection<CabinetWithoutAppliance> =
  new RawAliasReflection<CabinetWithoutAppliance>('CabinetWithoutAppliance', [
    Drawer33Door66,
    FullDoorBase,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase,
  ])

export type Part = Filler
export const Part: RawAliasReflection<Part> = new RawAliasReflection<Part>('Part', [Filler])

export type WallItemWithDefaultCountertop = Drawer33Door66 | Filler | FullDoorBase | ThreeDrawerBase | TrashPulloutBase
export const WallItemWithDefaultCountertop: RawAliasReflection<WallItemWithDefaultCountertop> =
  new RawAliasReflection<WallItemWithDefaultCountertop>('WallItemWithDefaultCountertop', [
    Drawer33Door66,
    Filler,
    FullDoorBase,
    ThreeDrawerBase,
    TrashPulloutBase,
  ])

export type WallItemWithCustomCountertop = BurnerBaseW18 | BurnerBaseW24 | EvoBaseW36 | GrillBase
export const WallItemWithCustomCountertop: RawAliasReflection<WallItemWithCustomCountertop> =
  new RawAliasReflection<WallItemWithCustomCountertop>('WallItemWithCustomCountertop', [
    BurnerBaseW18,
    BurnerBaseW24,
    EvoBaseW36,
    GrillBase,
  ])

export type Cabinet =
  | BurnerBaseW18
  | BurnerBaseW24
  | Drawer33Door66
  | EvoBaseW36
  | FullDoorBase
  | GrillBase
  | SinkBase
  | ThreeDrawerBase
  | TrashPulloutBase
export const Cabinet: RawAliasReflection<Cabinet> = new RawAliasReflection<Cabinet>('Cabinet', [
  BurnerBaseW18,
  BurnerBaseW24,
  Drawer33Door66,
  EvoBaseW36,
  FullDoorBase,
  GrillBase,
  SinkBase,
  ThreeDrawerBase,
  TrashPulloutBase,
])

export type RoomItem = Appliance | Cabinet | Part
export const RoomItem: RawAliasReflection<RoomItem> = new RawAliasReflection<RoomItem>('RoomItem', [
  ...Appliance.reflections,
  ...Cabinet.reflections,
  ...Part.reflections,
])

export type WallItem = Cabinet | Filler
export const WallItem: RawAliasReflection<WallItem> = new RawAliasReflection<WallItem>('WallItem', [
  ...Cabinet.reflections,
  Filler,
])

export type EvoBase = EvoBaseW36
export const EvoBase: RawAliasReflection<EvoBase> = new RawAliasReflection<EvoBase>('EvoBase', [EvoBaseW36])

export type LynxProfessionalGrill =
  | LynxProfessionalGrillW30
  | LynxProfessionalGrillW36
  | LynxProfessionalGrillW42
  | LynxProfessionalGrillW54
export const LynxProfessionalGrill: RawAliasReflection<LynxProfessionalGrill> =
  new RawAliasReflection<LynxProfessionalGrill>('LynxProfessionalGrill', [
    LynxProfessionalGrillW30,
    LynxProfessionalGrillW36,
    LynxProfessionalGrillW42,
    LynxProfessionalGrillW54,
  ])

export type LynxSedonaGrill = LynxSedonaGrillW30 | LynxSedonaGrillW36 | LynxSedonaGrillW42
export const LynxSedonaGrill: RawAliasReflection<LynxSedonaGrill> = new RawAliasReflection<LynxSedonaGrill>(
  'LynxSedonaGrill',
  [LynxSedonaGrillW30, LynxSedonaGrillW36, LynxSedonaGrillW42]
)

export type ResizableWallItem =
  | Drawer33Door66
  | GrillBase
  | Filler
  | FullDoorBase
  | SinkBase
  | ThreeDrawerBase
  | TrashPulloutBase
export const ResizableWallItem: RawAliasReflection<ResizableWallItem> = new RawAliasReflection<ResizableWallItem>(
  'ResizableWallItem',
  [Drawer33Door66, GrillBase, Filler, FullDoorBase, SinkBase, ThreeDrawerBase, TrashPulloutBase]
)

export const aliases = {
  AnyDomainEntity: AnyDomainEntity.types,
  RootEntity: RootEntity.types,
  StaticEntity: StaticEntity.types,
  AdjustableDoorCabinet: AdjustableDoorCabinet.types,
  Appliance: Appliance.types,
  BurnerBase: BurnerBase.types,
  CabinetWithAppliance: CabinetWithAppliance.types,
  CabinetWithoutAppliance: CabinetWithoutAppliance.types,
  Part: Part.types,
  WallItemWithDefaultCountertop: WallItemWithDefaultCountertop.types,
  WallItemWithCustomCountertop: WallItemWithCustomCountertop.types,
  Cabinet: Cabinet.types,
  RoomItem: RoomItem.types,
  WallItem: WallItem.types,
  EvoBase: EvoBase.types,
  LynxProfessionalGrill: LynxProfessionalGrill.types,
  LynxSedonaGrill: LynxSedonaGrill.types,
  ResizableWallItem: ResizableWallItem.types,
} as const
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type Aliases = {
  AnyDomainEntity: AnyDomainEntity
  RootEntity: RootEntity
  StaticEntity: StaticEntity
  AdjustableDoorCabinet: AdjustableDoorCabinet
  Appliance: Appliance
  BurnerBase: BurnerBase
  CabinetWithAppliance: CabinetWithAppliance
  CabinetWithoutAppliance: CabinetWithoutAppliance
  Part: Part
  WallItemWithDefaultCountertop: WallItemWithDefaultCountertop
  WallItemWithCustomCountertop: WallItemWithCustomCountertop
  Cabinet: Cabinet
  RoomItem: RoomItem
  WallItem: WallItem
  EvoBase: EvoBase
  LynxProfessionalGrill: LynxProfessionalGrill
  LynxSedonaGrill: LynxSedonaGrill
  ResizableWallItem: ResizableWallItem
}

export const entities: EntityReflections<AnyDomainEntity> = {
  BurnerBaseW18,
  BurnerBaseW24,
  CornerFiller,
  Drawer33Door66,
  EvoBaseW36,
  EvoAffinity25G,
  EvoAffinity30G,
  Filler,
  FullDoorBase,
  GrillBase,
  LynxAsadoGriddgle,
  LynxProfessionalGrillW30,
  LynxProfessionalGrillW36,
  LynxProfessionalGrillW42,
  LynxProfessionalGrillW54,
  LynxProfessionalSingleBurner,
  LynxProfessionalDoubleBurner,
  LynxProfessionalPowerBurner,
  LynxSedonaGrillW30,
  LynxSedonaGrillW36,
  LynxSedonaGrillW42,
  LynxSedonaSingleBurner,
  LynxSedonaDoubleBurner,
  Room,
  SinkBase,
  ThreeDrawerBase,
  TrashPulloutBase,
  Wall,
} as const
